export const SUPPORTED_LANGUAGES = process.env.VUE_APP_SUPPORTED_LANGUAGES.split(',')
export const FALLBACK_LANGUAGE = process.env.VUE_APP_ENV === 'tr' ? 'tr' : 'th'
export const DEFAULT_LANGUAGE = (() => {
  const storedLanguage = localStorage.getItem('lang')
  if (storedLanguage) {
    return localStorage.getItem('lang')
  }
  const langString = window.navigator.language || window.navigator.userLanguage
  const lang = langString.split('-')[0]
  if (SUPPORTED_LANGUAGES.includes(lang)) {
    return lang
  }
  return FALLBACK_LANGUAGE
})()
export const DEFAULT_LOCALIZED_PROP = SUPPORTED_LANGUAGES.reduce((acc, lang) => {
  acc[lang] = ''
  return acc
}, {})
